import { createAsyncThunk } from '@reduxjs/toolkit';
import devicesRepository from '../domain/repositories/devices-repository';
import { DeviceDto } from 'modules/core/supabase/tables/device';

const PREFIX = 'devices';

export const createDevice = createAsyncThunk<DeviceDto, { name: string; tournament_id: number }>(
  `${PREFIX}/createDevice`,
  async (payload, { rejectWithValue }) => {
    try {
      return await devicesRepository.create(payload);
    } catch (error) {
      console.error(`${PREFIX}/createDevice error:`, error);
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue(message);
    }
  },
);

export const updateDevice = createAsyncThunk<
  DeviceDto,
  { id: number; params: Partial<{ name: string; tournament_id: number }> }
>(
  `${PREFIX}/updateDevice`,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      return await devicesRepository.update(id, params);
    } catch (error) {
      console.error(`${PREFIX}/updateDevice error:`, error);
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue(message);
    }
  },
);

export const deleteDevice = createAsyncThunk<boolean, number>(
  `${PREFIX}/deleteDevice`,
  async (id, { rejectWithValue }) => {
    try {
      return await devicesRepository.delete(id);
    } catch (error) {
      console.error(`${PREFIX}/deleteDevice error:`, error);
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue(message);
    }
  },
);
